class ManejadorErrores {
    static CODIGOS_ERROR = {
        ERROR_CORREO: 'ERROR_CORREO',
        ERROR_SHOPIFY: 'ERROR_SHOPIFY',
        ERROR_RED: 'ERROR_RED',
        ERROR_CONSULTA: 'ERROR_CONSULTA',
        ERROR_VALIDACION: 'ERROR_VALIDACION',
        ERROR_NEGOCIO: 'ERROR_NEGOCIO',
        ERROR_DESCONOCIDO: 'ERROR_DESCONOCIDO'
      };
    
      static MENSAJES_ERROR = {
        ERROR_CORREO: 'El correo electrónico no es válido',
        ERROR_SHOPIFY: 'No se pudo conectar con la tienda',
        ERROR_RED: 'Hay problemas de conexión',
        ERROR_CONSULTA: 'No se pudo completar la consulta',
        ERROR_VALIDACION: 'Los datos proporcionados no son válidos',
        ERROR_NEGOCIO: 'No se pudo completar la operación',
        ERROR_DESCONOCIDO: 'Ocurrió un error inesperado'
      };
    
  
    static registrarError(error, contexto) {
      console.error({
        fecha: new Date().toISOString(),
        operacion: contexto,
        tipo: error.codigo || this.CODIGOS_ERROR.ERROR_DESCONOCIDO,
        mensaje: error.mensaje || error.message,
        detalles: error.detalles || error,
        tienda: window.urlConsulta
      });
    }
  
    static manejarError(error, contexto) {
      this.registrarError(error, contexto);
  
      return {
        exito: false,
        mensaje: error.mensaje || this.MENSAJES_ERROR.ERROR_DESCONOCIDO,
        datos: null
      };
    }
  
    static crearError(codigo, detalles = {}) {
      return {
        codigo,
        mensaje: this.MENSAJES_ERROR[codigo],
        detalles
      };
    }
}